import React, { createContext, useContext, useState } from 'react';

const CourseContext = createContext();

export const useCourse = () => {
  const context = useContext(CourseContext);
  if (!context) {
    throw new Error('useCourse debe ser utilizado dentro de un CourseProvider');
  }
  return context;
};

export const CourseProvider = ({ children }) => {
  const [currentCourse, setCurrentCourse] = useState(null);
  const [courseModules, setCourseModules] = useState([]);
  const [currentModule, setCurrentModule] = useState(null);

  const setCourse = (course) => {
    setCurrentCourse(course);
    setCourseModules(course?.moduls || []);
    setCurrentModule(null);
  };

  const setModule = (moduleId) => {
    const module = courseModules.find(module => module._id === moduleId);
    setCurrentModule(module);
  };

  return (
    <CourseContext.Provider value={{ currentCourse, courseModules, setCourse, currentModule, setModule }}>
      {children}
    </CourseContext.Provider>
  );
};